import React, {useMemo, useState} from 'react'
import PropTypes from 'prop-types';
import GridBlock from "components/GridBlock";
import Loading from "components/Loading";
import Message from "./Message";
import Tr from "translations/Translations";
import Button from "components/Button";
import PostAddIcon from '@material-ui/icons/PostAdd';
import {makeStyles} from "@material-ui/core";
import CorrespondenceService from "services/CorrespondenceService";
import NewMessage from "./NewMessage";
import {connect} from "react-redux";
import PrivilegeService from "services/PrivilegeService";

const useStyle = makeStyles(theme => ({
    addButton: {
        float: 'right'
    }
}));

function MessagesList(
    {
        rfxRoundId,
        listResourceId,
        contractor,
        thread,
        currentActive,
        correspondencePrivileges
    }) {

    const classes = useStyle();
    const [addInProgress, setAddInProgress] = useState(false);
    const hasEdit = useMemo(()=> !!correspondencePrivileges.EDIT, [correspondencePrivileges]);

    if (!thread.messages) {
        return <Loading/>
    }

    const addMessageClick = () => {
        setAddInProgress(true);
        if(contractor) {
            CorrespondenceService.createContractorMessage(rfxRoundId, thread.threadId, listResourceId).finally(() => setAddInProgress(false));
        } else {
            CorrespondenceService.createBuyerMessage(rfxRoundId, thread.threadId, listResourceId).finally(() => setAddInProgress(false));
        }
    }

    return (
        <>
            <GridBlock column>
                {thread.messages.map((msg) => (
                    msg.status === 'saved' ?
                        <NewMessage key={msg.messageId} rfxRoundId={rfxRoundId} listResourceId={listResourceId} message={msg} threadId={thread.threadId} contractor={contractor} currentActive={currentActive}/>
                        :
                        <Message key={msg.messageId} rfxRoundId={rfxRoundId} listResourceId={listResourceId} message={msg} contractor={contractor} hasEdit={hasEdit}/>)
                )}

                {hasEdit && currentActive &&
                    <Button
                        className={classes.addButton}
                        onClick={addMessageClick}
                        disabled={addInProgress}>
                        <PostAddIcon/> {Tr('add_message_in_thread')}
                    </Button>
                }
            </GridBlock>
        </>
    )
}

MessagesList.propTypes = {
    classes: PropTypes.any,
}
const mapStateToProps = (state) => {
    return {
        correspondencePrivileges: state.privileges[PrivilegeService.CORRESPONDENCE_PRIVILEGE_STORE_KEY],
    }
}
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesList);